// Persistência local da POC de Jornada do Paciente.
// Tudo fica em localStorage — não há backend envolvido nesta prova de conceito.

const STORAGE_KEY = "lila_journey_board_poc_v4";

// pravatar entrega fotos de pessoas (placeholder real) variando pelo parâmetro img (1..70).
const placeholderAvatar = (imageSeed) => `https://i.pravatar.cc/140?img=${imageSeed}`;

export function generateId(prefix = "id") {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return `${prefix}-${crypto.randomUUID()}`;
  }
  return `${prefix}-${Date.now()}-${Math.floor(Math.random() * 1e6)}`;
}

function buildSeedBoard() {
  return {
    columns: [
      {
        id: "col-aguardando-exames",
        title: "Aguardando Exames",
        cards: [
          {
            id: generateId("card"),
            name: "Maria Oliveira",
            age: 54,
            specialty: "Cardiologia",
            summary: "Pré-operatório de revascularização",
            daysSinceDiagnosis: 9,
            avatar: placeholderAvatar(5)
          },
          {
            id: generateId("card"),
            name: "Luciano do Vale",
            age: 52,
            specialty: "Gastroenterologia",
            summary: "Investigação de dor abdominal",
            daysSinceDiagnosis: 23,
            avatar: placeholderAvatar(12)
          },
          {
            id: generateId("card"),
            name: "Ana Beatriz Souza",
            age: 47,
            specialty: "Oncologia",
            summary: "Estadiamento — nódulo mamário",
            daysSinceDiagnosis: 41,
            avatar: placeholderAvatar(45)
          }
        ]
      },
      {
        id: "col-aguardando-cirurgia",
        title: "Aguardando Cirurgia",
        cards: [
          {
            id: generateId("card"),
            name: "Carlos Mendes",
            age: 61,
            specialty: "Ortopedia",
            summary: "Artroplastia total de joelho",
            daysSinceDiagnosis: 52,
            avatar: placeholderAvatar(33)
          },
          {
            id: generateId("card"),
            name: "Fernanda Lima",
            age: 29,
            specialty: "Cirurgia Geral",
            summary: "Colecistectomia laparoscópica",
            daysSinceDiagnosis: 5,
            avatar: placeholderAvatar(48)
          }
        ]
      },
      {
        id: "col-pos-cirurgia",
        title: "Pós-Cirurgia",
        cards: [
          {
            id: generateId("card"),
            name: "Roberto Alves",
            age: 70,
            specialty: "Cardiologia",
            summary: "D+3 pós-ponte de safena",
            daysSinceDiagnosis: 34,
            avatar: placeholderAvatar(60)
          },
          {
            id: generateId("card"),
            name: "Juliana Castro",
            age: 45,
            specialty: "Oncologia",
            summary: "Pós-mastectomia — acompanhamento",
            daysSinceDiagnosis: 58,
            avatar: placeholderAvatar(20)
          }
        ]
      }
    ]
  };
}

// Cria load/save/reset para um quadro guardado numa chave do localStorage.
// A Jornada usa o quadro abaixo; o Ambulatório (POC Cuidados Paliativos)
// reaproveita a mesma tela com outra chave e outro exemplo inicial.
export function createBoardStore(storageKey, buildSeed) {
  function save(board) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(board));
    } catch (error) {
      console.warn("Falha ao salvar o quadro no localStorage.", error);
    }
  }

  function load() {
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed && Array.isArray(parsed.columns)) {
          return parsed;
        }
      }
    } catch (error) {
      console.warn("Falha ao ler o quadro do localStorage, recriando exemplo.", error);
    }
    const seed = buildSeed();
    save(seed);
    return seed;
  }

  function reset() {
    const seed = buildSeed();
    save(seed);
    return seed;
  }

  return { loadBoard: load, saveBoard: save, resetBoard: reset };
}

const journeyStore = createBoardStore(STORAGE_KEY, buildSeedBoard);

export const loadBoard = journeyStore.loadBoard;
export const saveBoard = journeyStore.saveBoard;
export const resetBoard = journeyStore.resetBoard;
